export class Enquiry {
  constructor() {
  }

  show(el) {
    el?.closest('.c-form-group')?.classList.remove('u-hidden');
  }

  hide(el) {
    el?.closest('.c-form-group')?.classList.add('u-hidden');
  }

  hideFieldsOnLoad(fields) {
    fields.forEach((field) => this.hide(field));
  }

  showFields(fields) {
    fields.forEach((field) => this.show(field));
  }

  toggleField(triggers, callback) {
    triggers.forEach((trigger) => {
      trigger.addEventListener('change', () => callback());
    });
  }

  handleFieldDisplay(condition, showFields = [], hideFields = []) {
    showFields.forEach(el => condition ? this.show(el) : this.hide(el));
    hideFields.forEach(el => !condition ? this.show(el) : this.hide(el));
  }

  addSubmitEventHandler(form) {
    form.addEventListener('submit', (event) => {
      const submittedClass = 'submitted';
      if (event.target.classList.contains(submittedClass)) {
        event.preventDefault();
      } else {
        event.target.classList.add(submittedClass);
      }
    });
  }
}
